import notifications from '../../notifications.js';
import uploadDocuments from '../../upload-documents.js';

const clean = () => {
	const children = document
		.getElementsByClassName('js-confirm-modal')[0]
		.getElementsByClassName('js-notify__text-wrapper')[0].children;

	const removeChildren = [];
	for (let i = 0; i < children.length; i += 1) {
		if (children[i].classList.contains('js-types')) {
			removeChildren.push(children[i]);
		}
	}
	for (let i = 0; i < removeChildren.length; i += 1) {
		removeChildren[i].parentNode.removeChild(removeChildren[i]);
	}
};
const addTypes = (texts) => {
	let htmlTemplate = '';
	if (texts.uploadTitle) {
		htmlTemplate += `<p class="js-types">${texts.uploadTitle}</p><ul class="js-types">`;
		for (let i = 0; i < texts.uploadDocuments.length; i += 1) {
			htmlTemplate += `<li>${texts.uploadDocuments[i]}</li>`;
		}
		htmlTemplate += '</ul>';
	}

	document
		.getElementsByClassName('js-confirm-modal')[0]
		.getElementsByClassName('js-notify__text-wrapper')[0]
		.innerHTML += htmlTemplate;
};

function show(kycResponse, viewDoneResolver, confirmCallback) {
	const texts = kycResponse.kycPopup.contentKYC;

	uploadDocuments.fetchHasDocuments()
		.then((hasDocuments) => {
			let icon;
			if (hasDocuments) {
				icon = 'has-documents';
			} else {
				icon = 'empty-documents';
			}
			notifications.showConfirmationMessage(icon, texts.message, texts.secondaryMessage, kycResponse.kycPopup.confirm,
				() => {
					clean();
					confirmCallback();
				},
				kycResponse.kycPopup.close, {
					closeCallback: () => {
						viewDoneResolver({ status: 'close' });
						clean();
					},
					viewReadyCallback: () => {
						clean();
						addTypes(texts);
					}
				}
			);
		});
}

export default {
	show
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/withdraw/kyc-popup.js